import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { addClass, Bem } from '../../utils/css.js';
import { useMergedRefs } from '../../utils/component-util.js';
import '../../constants.js';
import { NavigationContext } from './NavigationContext.js';
import './NavigationItem.scss.js';

const bem = Bem.create("vai-navigation-item");
const NavigationItem = React.forwardRef((props, forwardedRef) => {
  const { children, className, menuKey, dataTa, htmlId, icon, _internalRef, onClick, ...rest } = props;
  const id = Id.create(htmlId, ["navigation menu item"]);
  const navigation = React.useContext(NavigationContext);
  const isSelected = navigation.selectedKey !== void 0 && navigation.selectedKey === menuKey;
  const clickHandler = React.useCallback((event) => {
    navigation.onSelectItem?.({
      menuKey,
      domEvent: event
    });
    onClick?.(event);
  }, [navigation, menuKey, onClick]);
  const mergedRefs = useMergedRefs(forwardedRef, _internalRef);
  return /* @__PURE__ */ React.createElement("li", {
    id: id.toString(),
    role: "menuitem",
    className: addClass(bem.block(isSelected && "selected"), className),
    ref: mergedRefs,
    onClick: clickHandler,
    ...rest
  }, icon && /* @__PURE__ */ React.createElement("span", {
    className: bem.element("icon")()
  }, icon), React.isValidElement(children) ? children : /* @__PURE__ */ React.createElement("span", null, children));
});

export { NavigationItem };
